<template>
  <h1>details page {{this.$route.params.id}}</h1>
</template>

<script>
export default {
  name: 'paramsPage'
}
</script>

<style scoped>

</style>
